import { useState } from "react";

export const useCheckbox = <T, K extends string | number>(
  getItemKey: (item: T) => K = (item: any) => item.id
) => {
  type SelectedType = { keys: K[]; items: Record<K, T> };

  const [selected, setSelected] = useState<SelectedType>({
    keys: [],
    items: {} as Record<K, T>,
  });

  const toggle = (item: T) => {
    const key = getItemKey(item);
    const { keys, items } = selected;
    const selectedCloned = structuredClone(keys);
    const selectedIndex = selectedCloned.indexOf(key);

    let newSelected: SelectedType = {
      items,
      keys: [],
    };

    if (selectedIndex === -1) {
      newSelected.keys = newSelected.keys.concat(keys, key);
      Object.assign(newSelected.items, { [key]: item });
    } else {
      if (selectedIndex === 0) {
        newSelected.keys = newSelected.keys.concat(keys.slice(1));
      } else if (selectedIndex === keys.length - 1) {
        newSelected.keys = newSelected.keys.concat(keys.slice(0, -1));
      } else if (selectedIndex > 0) {
        newSelected.keys = newSelected.keys.concat(
          keys.slice(0, selectedIndex),
          keys.slice(selectedIndex + 1)
        );
      }

      delete newSelected.items[key];
    }

    setSelected(newSelected);

    return newSelected.keys;
  };

  const checked = (item: K) => {
    return selected.keys.includes(item);
  };

  return {
    keys: selected.keys,
    items: selected.items,
    length: selected.keys.length,
    toggle,
    checked,
  };
};
